/** Same format as the award sheet PDF (apps/api/src/modules/bidCommittee/lib/awardSheetPdfDate.ts). */
const DHI_MONTHS = [
    "ޖެނުއަރީ",
    "ފެބްރުއަރީ",
    "މާޗް",
    "އޭޕްރިލް",
    "މޭ",
    "ޖޫން",
    "ޖުލައި",
    "އޯގަސްޓް",
    "ސެޕްޓެމްބަރ",
    "އޮކްޓޯބަރ",
    "ނޮވެމްބަރ",
    "ޑިސެމްބަރ",
];
function pad2(n) {
    return String(n).padStart(2, "0");
}
function formatTime(d) {
    return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}
/** Meeting date/time for award sheet PDF, as on the template: `28 މޭ 2025 (13:00 14:00 އަށް)`. */
export function formatAwardSheetMeetingDateTime(plannedStart, actualEnd) {
    if (!plannedStart)
        return "—";
    const start = typeof plannedStart === "string" ? new Date(plannedStart) : plannedStart;
    if (Number.isNaN(start.getTime()))
        return "—";
    const day = start.getDate();
    const month = DHI_MONTHS[start.getMonth()] ?? "";
    const year = start.getFullYear();
    const startTime = formatTime(start);
    let range = startTime;
    if (actualEnd) {
        const end = typeof actualEnd === "string" ? new Date(actualEnd) : actualEnd;
        if (!Number.isNaN(end.getTime())) {
            range = `${startTime} ${formatTime(end)} އަށް`;
        }
    }
    return `${day} ${month} ${year} (${range})`;
}
//# sourceMappingURL=awardSheetMeetingDate.js.map